import { loader } from '@/components/Loader.js';
import {appNotification} from '@/components/AppNotification.js'
import { server } from '@/components/Server.js';

const modal = {
  activeTab: "notifications",

  view: function () {
    const unreadNotesCount = appNotification.filteredNotes.filter(
      (item) => !item.IsRead
    ).length;
    const unreadNotificationsCount = appNotification.notifications.filter(
      (item) => !item.read
    ).length;

    return m(
      ".popup",
      m(".popup-content", [
        m(".container", [
          m(".row.bg-primary[style='padding:10px']", [
            m("span", "Требует вашего внимания"),
            m("span.pull-right", { onclick: modalContainer.close }, [
              m("i.glyphicon.glyphicon-remove"),
              m.trust("&nbsp;Закрыть"),
            ]),
          ]),
          m(".modal-tabs", [
            m(
              "span.modal-tab",
              {
                class: modal.activeTab === "notifications" ? "selected" : "",
                onclick: () => {
                  modal.activeTab = "notifications";
                },
              },
              [
                "Уведомления",
                unreadNotificationsCount > 0
                  ? m(".modal-badge", unreadNotificationsCount)
                  : null,
              ]
            ),
            m(
              "span.modal-tab",
              {
                class: modal.activeTab === "notes" ? "selected" : "",
                onclick: () => {
                  modal.activeTab = "notes";
                },
              },
              [
                "Примечания",
                unreadNotesCount > 0
                  ? m(".modal-badge", unreadNotesCount)
                  : null,
              ]
            ),
          ]),
          modal.activeTab === "notifications"
            ? m(".notification-list", [
                appNotification.notifications.map(function (item, i) {
                  return m(".media[style='margin:7px 0']", [
                    m(".media-left", [
                      m("img.media-object[style='width:60px;height:60px']", {
                        src: item?.icon?.replace('/resources',''),
                      }),
                    ]),
                    m(".media-body", item.text),
                    m(".media-right", [
                      m(
                        "button.btn.btn-info.btn-lg",
                        {
                          onclick: function () {
                            appNotification.markRead(i);
                          },
                        },
                        [m("i.fa.fa-2x.fa-thumbs-o-up")]
                      ),
                    ]),
                  ]);
                }),
              ])
            : m(".notification-container", [
                appNotification.filteredNotes.some((notification) => !notification.IsRead)
                  ? m(
                      ".read-all-btn",
                      {
                        onclick: function () {
                          appNotification.markAllReadNote();
                        },
                      },
                      "Прочитать всё"
                    )
                  : null,
                m(".notification-list", [
                  appNotification.filteredNotes.map(function (item) {
                    const textLength = item.fileName ? 100 : 50;
                    const isTextLong = item.Text.length > textLength;
                    const isExpanded = item.expanded || !isTextLong;
                    let headerText = "";
                    if (item.Company) {
                      headerText += item.Flight_Num;
                    }
                    if (item.Stand) {
                      headerText += `, МС: ${item.Stand}`;
                    }
                    if (item.Gate) {
                      headerText += `, Gate: ${item.Gate}`;
                    }

                    return m(".media[style='margin:5px 0 20px']", [
                      m(".media-body", [
                        m(
                          "div.note-text.note-text-header",
                          m.trust("<b>" + headerText + "</b>")
                        ),
                        m(
                          "div.note-text",
                          {
                            onclick: () => {
                              item.expanded = !item.expanded;
                            },
                          },
                          isExpanded
                            ? item.Text
                            : item.Text.slice(0, textLength) + "..."
                        ),
                        item.expanded && isTextLong
                          ? m("div.expanded-text", item.Text.slice(textLength))
                          : null,
                      ]),
                      m(".media-right", [
                        m(".modal-btns", [
                          item.FileName
                            ? m(
                                "button.btn.btn-info.btn-lg.modal-btn",
                                {
                                  onclick: () => getFile(item.Note_ID),
                                },
                                [m("i.fa.fa-2x.fa-folder-o")]
                              )
                            : null,
                          m(
                            "button.btn.btn-info.btn-lg.modal-btn",
                            {
                              onclick: function () {
                                if (!item.IsRead) {
                                  if (isExpanded) {
                                    appNotification.markReadNote(
                                      item.Notification_ID
                                    );
                                  } else {
                                    item.expanded = true;
                                  }
                                }
                              },
                              disabled: item.IsRead,
                              class: item.IsRead ? "disabled" : "",
                            },
                            [
                              !item.IsRead && !item.expanded && isTextLong
                                ? m("i.fa.fa-2x.fa-arrow-down")
                                : m("i.fa.fa-2x.fa-thumbs-o-up"),
                            ]
                          ),
                        ]),
                      ]),
                    ]);
                  }),
                ]),
              ]),
        ]),
      ])
    );
  },
};

export const modalContainer = {
  container: null,

  open: function () {
    modalContainer.container = document.querySelector("#modal-container");
    if (!modalContainer.container) {
      modalContainer.container = document.createElement("div");
      modalContainer.container.id = "modal-container";
      document.body.appendChild(modalContainer.container);
      m.mount(modalContainer.container, m.component(modal));
    }
    // notification.stop();
    if (!appNotification.notifications.length && appNotification.filteredNotes.length) {
      modal.activeTab = 'notes'
    } else {
      modal.activeTab = 'notifications'
    }
    m.redraw();
  },

  close: function () {
    m.mount(modalContainer.container, null);
    document.body.removeChild(modalContainer.container);
    modalContainer.container = null;
    appNotification.reset();
  },

  redraw: function() {
    m.redraw();
  }
};

function getFile(id_note) {
  loader.show();
  m.request({
    url: `/api/get-note-file/${id_note}`,
    method: "GET",
    extract(xhr) {
      const statusErr = [401, 403];
      return statusErr.includes(xhr.status) ? xhr.status : xhr.response;
    },
  }).then(
    function (res) {
      const file = res.fileData;
      const name = res.fileName;

      if (typeof file === "string") {
        const byteCharacters = atob(file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: "application/octet-stream",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      }
      loader.hide();
    },
    function (err) {
      loader.hide();
      server.setOffline(err);
    }
  );
}
